(() => {
  const STORAGE_KEY = 'betterboat_prop65_ca_session_v1';
  const blocks = document.querySelectorAll('[data-prop65-warning]');

  if (!blocks.length) return;

  const reveal = () => {
    blocks.forEach((block) => {
      block.hidden = false;
      block.setAttribute('data-prop65-visible', 'true');
    });
    document.querySelectorAll('[data-ca-right-to-know]').forEach((link) => {
      link.hidden = false;
      link.setAttribute('data-ca-right-to-know-visible', 'true');
    });
  };

  const readCached = () => {
    try {
      const raw = window.sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      return typeof parsed.california === 'boolean' ? parsed : null;
    } catch (_) {
      return null;
    }
  };

  const writeCached = (value) => {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        california: Boolean(value.california),
        source: value.source || 'cloudflare-worker',
        checkedAt: Date.now(),
      }));
    } catch (_) {}
  };

  const cached = readCached();
  if (cached) {
    if (cached.california) reveal();
    return;
  }

  const endpoint = window.BetterBoatProp65GeoEndpoint;
  if (!endpoint) return;

  fetch(endpoint, {
    method: 'GET',
    mode: 'cors',
    credentials: 'omit',
    cache: 'force-cache',
    keepalive: true,
  })
    .then((response) => (response.ok ? response.json() : Promise.reject(new Error('geo_failed'))))
    .then((data) => {
      const california = Boolean(data && data.california);
      writeCached({ california });
      if (california) reveal();
    })
    .catch(() => {
      writeCached({ california: false, source: 'geo-error' });
    });
})();
